import React from 'react';

import EngineeringIcon from '@mui/icons-material/Engineering';
import { useTheme } from '@mui/material/styles';
import {
    List,
    ListItem,
    ListItemButton,
    ListItemText,
} from '@sunwisesoftware/sunwise-ui';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import DropdownCardMenu from 'common/components/DropdownCardMenu';
import { TEMPLATE_TYPES } from 'common/constants';

import { getDocumentItemSx } from '../helpers';

import SideMenuCard from './SideMenuCard';

const SystemsCard = ({
    documents,
    handleClickDocumentItem,
    handleClickEditButton,
    isDisabled,
    selectedDocumentId,
}) => {
    const { t } = useTranslation();
    const theme = useTheme();
    if (isEmpty(documents)) return null;
    return (
        <SideMenuCard
            icon={<EngineeringIcon sx={{ color: 'primary.main' }} />}
            title={t('System', { count: 2 })}
        >
            <List disablePadding>
                {documents.map((document) => (
                    <ListItem
                        disabled={
                            isDisabled || document.id === selectedDocumentId
                        }
                        disablePadding
                        key={`system-document-${document.id}`}
                        secondaryAction={
                            <DropdownCardMenu
                                disabled={isDisabled}
                                items={[
                                    {
                                        handleClick: () =>
                                            handleClickEditButton(),
                                        label: t('Edit'),
                                    },
                                ]}
                                sxIconButton={{
                                    '&:hover': {
                                        backgroundColor: 'transparent',
                                    },
                                }}
                                visible={document.id === selectedDocumentId}
                            />
                        }
                        selected={document.id === selectedDocumentId}
                        sx={getDocumentItemSx(theme)}
                    >
                        <ListItemButton
                            onClick={() =>
                                handleClickDocumentItem({
                                    contentId: document.id,
                                    id: document.id,
                                    name: document.name,
                                    type: TEMPLATE_TYPES.SYSTEM_TYPE,
                                })
                            }
                            sx={{ borderRadius: '8px' }}
                        >
                            <ListItemText primary={document.name} />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </SideMenuCard>
    );
};

SystemsCard.propTypes = {
    documents: PropTypes.array,
    handleClickDocumentItem: PropTypes.func,
    handleClickEditButton: PropTypes.func,
    isDisabled: PropTypes.bool,
    selectedDocumentId: PropTypes.string,
};

export default SystemsCard;
